import { Accordion, AccordionTab } from "primereact/accordion"
import styles from "../../../styles/Participant-Employment.module.css"
const CareerProfileViewTable = ({ content, label }) => {
  return (
    <Accordion className={"custom_accordion"} style={{ width: "100%" }}>
      <AccordionTab
        header={
          <h3
            className={styles.view_subtitle}
            style={{
              color: "#383838",
              fontWeight: "600",
            }}
          >
            {label}
          </h3>
        }
      >
        <div className={styles.table_group}>
          <div
            style={{ display: "flex", justifyContent: "space-between" }}
          ></div>
          {content()}
        </div>
      </AccordionTab>
    </Accordion>
  )
}
export default CareerProfileViewTable
